import { render, staticRenderFns } from "./consultInfo.vue?vue&type=template&id=5c94f9b3&scoped=true&"
import script from "./consultInfo.vue?vue&type=script&lang=js&"
export * from "./consultInfo.vue?vue&type=script&lang=js&"
import style0 from "./consultInfo.vue?vue&type=style&index=0&id=5c94f9b3&scoped=true&lang=css&"
import style1 from "./consultInfo.vue?vue&type=style&index=1&id=5c94f9b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c94f9b3",
  null
  
)

export default component.exports